import { FC } from 'react';

import { SurveyOverviewRowType } from './SurveyOverviewRow';

import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';
import { SURVEY_OVERVIEW_ROW_TEST_IDS } from '@/constants/data-testids';

import { TableCell, TableRow } from '../Table/Table';

type SurveyOverviewRowSkeletonProps = {
  type: SurveyOverviewRowType;
};

export const SurveyOverviewRowSkeleton: FC<SurveyOverviewRowSkeletonProps> = ({ type }) => {
  const showCompletetionRateCell = type === 'active' || type === 'finished';
  const showDateCells = type !== 'drafts';

  return (
    <TableRow data-testid={SURVEY_OVERVIEW_ROW_TEST_IDS.SKELETON}>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <div className="flex items-center gap-2">
          <Skeleton className="h-[14px] min-w-[72px] w-full" />
          <Skeleton className="h-[14px] min-w-[72px] w-full" />
          <Skeleton className="h-[14px] min-w-[72px] w-full" />
          {!showDateCells && <Skeleton className="h-[14px] w-full" />}
        </div>
      </TableCell>
      {showCompletetionRateCell && (
        <TableCell>
          <Skeleton className="h-[14px] w-full" />
        </TableCell>
      )}
      {showDateCells && (
        <TableCell>
          <Skeleton className="h-[14px] w-full" />
        </TableCell>
      )}
      {showDateCells && (
        <TableCell>
          <Skeleton className="h-[14px] w-full" />
        </TableCell>
      )}
      <TableCell>
        <div className="flex items-center justify-between gap-2">
          <Skeleton className="h-[14px] shrink-0 size-6 rounded-full" />
          <Skeleton className="h-[14px] w-full" />
        </div>
      </TableCell>
    </TableRow>
  );
};
